import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SERVER_API_URL } from 'src/app/app.constants';
import { createRequestOption } from 'src/app/shared/util/request-util';
import { ICargoGroupMySuffix } from 'src/app/shared/model/cargo-group-my-suffix.model';

type EntityResponseType = HttpResponse<ICargoGroupMySuffix>;
type EntityArrayResponseType = HttpResponse<ICargoGroupMySuffix[]>;

@Injectable({ providedIn: 'root' })
export class CargoGroupMySuffixService {
    
    private resourceUrl = SERVER_API_URL + 'api/cargo-groups';
    private resourceUrlView = SERVER_API_URL + 'api/cargo-groups/view';
    constructor(private http: HttpClient) {}

    create(cargoGroup: ICargoGroupMySuffix): Observable<EntityResponseType> {
        return this.http.post<ICargoGroupMySuffix>(this.resourceUrl, cargoGroup, { observe: 'response' });
    }

    update(cargoGroup: ICargoGroupMySuffix): Observable<EntityResponseType> {
        return this.http.put<ICargoGroupMySuffix>(this.resourceUrl, cargoGroup, { observe: 'response' });
    }

    find(id: number): Observable<EntityResponseType> {
        return this.http.get<ICargoGroupMySuffix>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    query(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ICargoGroupMySuffix[]>(this.resourceUrl, { params: options, observe: 'response' });
    }

    delete(id: number): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.resourceUrl}/${id}`, { observe: 'response' });
    }

    queryAll(req?: any): Observable<EntityArrayResponseType> {
        const options = createRequestOption(req);
        return this.http.get<ICargoGroupMySuffix[]>(this.resourceUrl + '/all', { params: options, observe: 'response' });
    }

    view(id: number): Observable<EntityResponseType> {
        return this.http.get<ICargoGroupMySuffix>(`${this.resourceUrlView}/${id}`, { observe: 'response' });
    }

    findByIdAndFromEffectiveDate(id: number, fromEffectiveDate: string): Observable<EntityResponseType> {
        return this.http.get<ICargoGroupMySuffix>(`${this.resourceUrl}/${id}/${fromEffectiveDate}`, { observe: 'response' });
    }
}
